import React, { Component } from 'react';
import { AreaInput, TextInput } from '../../../lib/components/textInput';
import { store } from "../../../testStore";

import { setRoleInfo, setRoleEmpty } from "../../../testActions";
/* React Router */
import { withRouter } from 'react-router-dom'


/* Redux */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';

/* Sagas Action */
import { buildWBoundActions, buildWSelector } from '../../../redux/ducks'
import { actions as notificationActions } from '../../../redux/ducks/notification'

/* Routes */
import { domainIsTenant as dit, S } from '../../../routes/routes'

/* Object Json */
import { parseAny, safeGetWithType } from 'iotera-base/json';
import { _N, isEmpty } from 'iotera-base/object'

import { IoteraForm } from '../../../lib/components/form';
import { SubViewHeader } from '../../../lib/components/subHeader';
import Result from 'iotera-base/result';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../../lib/components/callbackGlobal';

const ADD = 'ADD'
const WKEY = 'ROLE_ADD';
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

const onError = (errors) => console.log("Ada", errors.length, "error yang harus diperbaiki");

function schema() {
  return {
    type: "object",
    required: ["name", 'permissions'],
    properties: {
      name: { type: "string", minLength: 1, maxLength: 30, pattern: '^[A-Za-z\\d][A-Za-z\\d_]+$' },
      description: { type: "string", default: '' },
      permissions: { type: 'string', title: 'Permissions', default: '{}' },
    }
  }
};

function uiSchema() {
  return {
    name: {
      "ui:widget": (props) => {
        return (
          <TextInput
            id="name"
            type="text"
            label="Nama"
            placeholder="Admin"
            textTooltip="Masukkan nama untuk identifikasi role ini"
            value={props.value}
            onError={onError}
            required={props.required}
            onChange={event => props.onChange(event.target.value)}
          />
        )
      },
      "ui:options": {
        label: false
      }
    },
    description: {
      "ui:widget": (props) => {
        return (
          <TextInput
            id="description"
            type="text"
            label="Deskripsi"
            placeholder="Deskripsi role"
            textTooltip="Masukkan deskripsi untuk role ini"
            value={props.value}
            onError={onError}
            required={props.required}
            onChange={event => props.onChange(event.target.value)}
          />
        )
      },
      "ui:options": {
        label: false
      }
    },
    permissions: {
      'ui:widget': props => {
        return (
          <AreaInput
            id="permissions"
            type="text"
            label="Permissions"
            textTooltip="Permissions"
            value={props.value}
            required={props.required}
            onChange={event => props.onChange(event.target.value)}
            areaHeight={200}
            {...props}
          />
        );
      },
      'ui:options': {
        label: false,
      },
    },
  }
};


class RoleAdd extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: [],
      formData: {},
      values: '',
      isSubmit: false
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.schema = schema();
    this.uiSchema = uiSchema();
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props
    const domainIsTenant = dit(_props);
    // callback global
    setCallbackGlobal(_props)
    _props.wInitRequestCall(
      {
        wparam: { ...domainIsTenant, path: "/service/web/application/nav/list" },
        wcallback: {
          started: function (id) {
            // TODO Loading
          },
          finished: function (id, result) {
            // TODO Loading
            _this.setState({
              loading: false
            })
          }
        }
      }
    );
    _props.wSetConfig({
      single_config: {
        [ADD]: {
          wparam: {
            ...domainIsTenant,
            method: "POST",
            path: "/service/web/application/account/role/add"
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  let action = setRoleEmpty();
                  store.dispatch(action)
                  _props.history.push('.' + S + '_role_list_');
                  _this.setState({
                    loading: false
                  })
                  _props.showSingleNotification({ message: 'Tambah Role Sukses', level: 'success' });
                  return;
                }
              }
              _this.setState({
                loading: false
              })
              _props.showSingleNotification({ message: 'Tambah Role Gagal', position: 'tr', level: 'error' });
            }
          }
        }
      }
    });
  }

  componentWillUnmount() {
    // callback global
    unsetCallbackGlobal(this.props)
  }

  goTo(link) {
    let action = setRoleEmpty();
    store.dispatch(action)
    this.props.history.push(link)
  }

  handleChange(event) {
    this.setState({ formData: event.formData });
  }

  handleSubmit(event) {
    const _this = this;
    const _props = _this.props
    let navs = _props.navs;
    let submitData = event['formData'];
    console.log(submitData);

    const name = submitData['name'];
    const description = submitData['description'];
    const permissions = submitData['permissions'];
    const permissionsParsed = parseAny(permissions);

    if (_N(permissionsParsed)) {
      _props.showSingleNotification({
        message: 'Invalid JSON for `Permissions`',
        level: 'warning',
      });
      return;
    }

    if (isEmpty(navs)) {
      _props.wSingleRequestCall({
        id: ADD,
        body: {
          name,
          description,
          descendant: false,
          navs: [],
          permissions: permissionsParsed
        }
      });
      return;
    }
    let role =
    {
      name,
      description,
      permissions: permissionsParsed
    }
    let action = setRoleInfo(role);
    _this.setState({
      formData: submitData
    })
    store.dispatch(action)
    _props.history.push('.' + S + '_role_add_access_')
  }

  render() {
    const _this = this;
    const _props = _this.props
    const state = this.state;
    const { formData } = state;

    let navs = _props.navs;
    let textNext = 'Berikutnya'
    if (isEmpty(navs)) {
      textNext = 'Simpan'
    }
    // let storeValue = store.getState();
    
    // let dataToShow = storeValue;
    // if (isEmpty(dataToShow)) {
    //   dataToShow = {}
    // } else {
    //   if ('role' in dataToShow) {
    //     if (isEmpty(dataToShow.role)) {
    //       dataToShow = {}
    //     } else {
    //       dataToShow = dataToShow.role;
    //     }
    //   } else {
    //     dataToShow = {}
    //   }
    // }

    return (
      <div className="view">
        <SubViewHeader title='Tambah Role' subTitle='Permohonan Tambah Role Baru' />
        <div className="io-container mt-12">
          <IoteraForm
            schema={this.schema}
            uiSchema={this.uiSchema}
            onChange={_this.handleChange}
            onSubmit={_this.handleSubmit}
            formData={formData}
          >
            <div className="button-right" style={{ marginTop: 10 }}>
              <button className="button-iotera-white" type="button" style={{ minWidth: '0%' }}
                onClick={(e) => _this.goTo('.' + S + '_role_list_')} >Batal</button>
              <button className="button-iotera-primary" type="submit"
                style={{ marginLeft: 10, minWidth: '0%' }}>{textNext}</button>
            </div>
          </IoteraForm>
        </div>
      </div>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    navs: wSelector.getSoleInitMappedRPayload(state, 'navs')
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RoleAdd));